var map = {
	"./+admin": [
		"./src/app/+admin/admin.module.ts",
		"default~admin~change-plan-history~dashboard~page~plan~promotion~ticket~topup-credit-history~user",
		"default~admin~change-plan-history~page~plan~promotion~sweetalert2~ticket~topup-credit-history~user",
		"default~admin~change-plan-history~plan~promotion~ticket~topup-credit-history~user",
		"default~admin~dashboard~page~plan~user",
		"default~admin~user",
		"admin"
	],
	"./+change-plan-history": [
		"./src/app/+admin/+change-plan-history/change-plan-history.module.ts",
		"default~admin~change-plan-history~dashboard~page~plan~promotion~ticket~topup-credit-history~user",
		"default~admin~change-plan-history~page~plan~promotion~sweetalert2~ticket~topup-credit-history~user",
		"default~admin~change-plan-history~plan~promotion~ticket~topup-credit-history~user",
		"default~change-plan-history~page~plan~promotion~ticket~topup-credit-history",
		"default~change-plan-history~plan~promotion~ticket~topup-credit-history",
		"default~change-plan-history~plan~ticket~topup-credit-history",
		"change-plan-history"
	],
	"./+dashboard": [
		"./src/app/+admin/+dashboard/dashboard.module.ts",
		"default~admin~change-plan-history~dashboard~page~plan~promotion~ticket~topup-credit-history~user",
		"default~admin~dashboard~page~plan~user",
		"dashboard"
	],
	"./+page": [
		"./src/app/+admin/+page/page.module.ts",
		"default~admin~change-plan-history~dashboard~page~plan~promotion~ticket~topup-credit-history~user",
		"default~admin~change-plan-history~page~plan~promotion~sweetalert2~ticket~topup-credit-history~user",
		"default~change-plan-history~page~plan~promotion~ticket~topup-credit-history",
		"default~admin~dashboard~page~plan~user",
		"page"
	],
	"./+plan": [
		"./src/app/+admin/+plan/plan.module.ts",
		"default~admin~change-plan-history~dashboard~page~plan~promotion~ticket~topup-credit-history~user",
		"default~admin~change-plan-history~page~plan~promotion~sweetalert2~ticket~topup-credit-history~user",
		"default~admin~change-plan-history~plan~promotion~ticket~topup-credit-history~user",
		"default~change-plan-history~page~plan~promotion~ticket~topup-credit-history",
		"default~change-plan-history~plan~promotion~ticket~topup-credit-history",
		"default~admin~dashboard~page~plan~user",
		"default~change-plan-history~plan~ticket~topup-credit-history",
		"plan"
	],
	"./+promotion": [
		"./src/app/+admin/+promotion/promotion.module.ts",
		"default~admin~change-plan-history~dashboard~page~plan~promotion~ticket~topup-credit-history~user",
		"default~admin~change-plan-history~page~plan~promotion~sweetalert2~ticket~topup-credit-history~user",
		"default~admin~change-plan-history~plan~promotion~ticket~topup-credit-history~user",
		"default~change-plan-history~page~plan~promotion~ticket~topup-credit-history",
		"default~change-plan-history~plan~promotion~ticket~topup-credit-history",
		"promotion"
	],
	"./+ticket": [
		"./src/app/+admin/+ticket/ticket.module.ts",
		"default~admin~change-plan-history~dashboard~page~plan~promotion~ticket~topup-credit-history~user",
		"default~admin~change-plan-history~page~plan~promotion~sweetalert2~ticket~topup-credit-history~user",
		"default~admin~change-plan-history~plan~promotion~ticket~topup-credit-history~user",
		"default~change-plan-history~page~plan~promotion~ticket~topup-credit-history",
		"default~change-plan-history~plan~promotion~ticket~topup-credit-history",
		"default~change-plan-history~plan~ticket~topup-credit-history",
		"ticket"
	],
	"./+topup-credit-history": [
		"./src/app/+admin/+topup-credit-history/topup-credit-history.module.ts",
		"default~admin~change-plan-history~dashboard~page~plan~promotion~ticket~topup-credit-history~user",
		"default~admin~change-plan-history~page~plan~promotion~sweetalert2~ticket~topup-credit-history~user",
		"default~admin~change-plan-history~plan~promotion~ticket~topup-credit-history~user",
		"default~change-plan-history~page~plan~promotion~ticket~topup-credit-history",
		"default~change-plan-history~plan~promotion~ticket~topup-credit-history",
		"default~change-plan-history~plan~ticket~topup-credit-history",
		"topup-credit-history"
	],
	"./+user": [
		"./src/app/+admin/+user/user.module.ts",
		"default~admin~change-plan-history~dashboard~page~plan~promotion~ticket~topup-credit-history~user",
		"default~admin~change-plan-history~page~plan~promotion~sweetalert2~ticket~topup-credit-history~user",
		"default~admin~change-plan-history~plan~promotion~ticket~topup-credit-history~user",
		"default~admin~dashboard~page~plan~user",
		"default~admin~user",
		"user"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;